import { useContext, useState } from 'react';
import Typography from '@mui/material/Typography';
import { BreadCrumbsCnt } from 'pages/documents/foldersDetailView/BreadCrumbs/breadCrumbs.style';

import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TemplateFolderIcon from 'components/Icons/templateFolderIcon';
import { DocumentsContext } from 'pages/documents/context/context';

function BreadCrumbs() {
  const { state = {}, updateState } = useContext(DocumentsContext);
  const { selectedFolder } = state;
  const [folder, _] = useState(selectedFolder);

  const backToChecklistHome = () => {
    updateState({ loading: true, selectedFolder: null });
  };

  return (
    <BreadCrumbsCnt>
      <Typography
        variant={'h1'}
        className={'heading'}
        onClick={backToChecklistHome}
      >
        Folders
      </Typography>
      <ArrowRightIcon className={'arrowIcon'} />
      <div className={'folderNameCnt'}>
        <TemplateFolderIcon
          primaryColor={folder?.meta?.primaryColor}
          secondaryColor={folder?.meta?.secondaryColor}
        />
        <Typography variant={'h1'} className={'folderName'}>
          {folder?.title}
        </Typography>
      </div>
    </BreadCrumbsCnt>
  );
}

export default BreadCrumbs;
